export default {
  // baseURL: 'http://gavinlaucn.xicp.net:41773',
  // baseURL: 'http://localhost:8080',
  // 官网ip
  // baseURL: 'http://50.112.198.13:8080',
  //官网域名
  baseURL: 'https://www.rgpharmaus.com:8080',
  // baseURL: 'http://207.231.113.130:8080',
  // baseURL: 'http://192.168.11.142:8187',
  // baseURL: 'http://10.1.1.52:8080',
  //baseURL: 'http://207.231.113.130:8080',
  api: [
    // API内容接口

    {
      name: 'getInfo',
      url: '/jee-cms/site/cmsSite/queryById',
      method: 'get',
    },
    // 友情链接
    {
      name: 'getFriendLink',
      url: '/jee-cms/site/cmsFriendLink/list',
      method: 'get',
    },
    /**
     * 首页
     * 接口地址英文:/jee-cms/site/cmsHomePage/queryById?id=1436533341209202689
     * 接口地址中文:/jee-cms/site/cmsHomePage/queryById?id=1436533510164156417
     * type: get
     */
    {
      name: 'getHome',
      url: '/jee-cms/site/cmsHomePage/queryById',
      method: 'get',
    },
    /**
     * 公司介绍
     * 接口地址英文:/jee-cms/site/cmsProfilePage/queryById?id=1435871157777055745
     * 接口地址中文:/jee-cms/site/cmsProfilePage/queryById?id=1436153120979111937
     * type: get
     */
    {
      name: 'getProfile',
      url: '/jee-cms/site/cmsProfilePage/queryById',
      method: 'get',
    },
    /**
     * 公司新闻
     * 接口地址英文:/jee-cms/site/cmsNewsPage/queryById?id=1436237504629329921
     * 接口地址中文:/jee-cms/site/cmsNewsPage/queryById?id=1435845950655832066
     * type: get
     */
    {
      name: 'getNews',
      url: '/jee-cms/site/cmsNewsPage/queryById',
      method: 'get',
    },

    /**
     * 团队管理
     * 接口地址英文:/jee-cms/site/cmsTeamPage/queryById?id=1436237899229450242
     * 接口地址中文:/jee-cms/site/cmsTeamPage/queryById?id=1436237936873328641
     * type: get
     */
    {
      name: 'getTeam',
      url: '/jee-cms/site/cmsTeamPage/queryById',
      method: 'get',
    },
    /**
     * 公司荣誉
     * 接口地址英文:/jee-cms/site/cmsHonorPage/queryById?id=1436503778160779265
     * 接口地址中文:/jee-cms/site/cmsHonorPage/queryById?id=1436503810528223234
     * type: get
     */
    {
      name: 'getHonor',
      url: '/jee-cms/site/cmsHonorPage/queryById',
      method: 'get',
    },
    /**
     * 合作伙伴
     * 接口地址英文:/jee-cms/site/cmsPartenerPage/queryById?id=1436505157793157121
     * 接口地址中文:/jee-cms/site/cmsPartenerPage/queryById?id=1436505183718150146
     * type: get
     */
    {
      name: 'getPartner',
      url: '/jee-cms/site/cmsPartenerPage/queryById',
      method: 'get',
    },
    /**
     * 服务 - 医学事业部
     * 接口地址英文:/jee-cms/site/cmsServicePage/queryById?id=1435944926294020097
     * 接口地址中文:/jee-cms/site/cmsServicePage/queryById?id=1436517096707559425
     * type: get
     */
    {
      name: 'getServiceYx',
      url: '/jee-cms/site/cmsServicePage/queryById',
      method: 'get',
    },
    /**
     * 服务 - 数据管理
     * 接口地址英文:/jee-cms/site/cmsServicePage/queryById?id=1437755580806049794
     * 接口地址中文:/jee-cms/site/cmsServicePage/queryById?id=1437755550976159746
     * type: get
     */
    {
      name: 'getServiceGl',
      url: '/jee-cms/site/cmsServicePage/queryById',
      method: 'get',
    },

    /**
     * 服务 - 生物统计
     * 接口地址英文:/jee-cms/site/cmsServicePage/queryById?id=1436463331191189505
     * 接口地址中文:/jee-cms/site/cmsServicePage/queryById?id=1436517197878366209
     * type: get
     */
    {
      name: 'getServiceTj',
      url: '/jee-cms/site/cmsServicePage/queryById',
      method: 'get',
    },

    /**
     * 首页
     * 接口地址英文:/jee-cms/site/cmsHomePage/queryById?id=1436533341209202689
     * 接口地址中文:/jee-cms/site/cmsHomePage/queryById?id=1436533510164156417
     * type: get
     */
    {
      name: 'getMoralInfo',
      url: '/jee-cms/site/cmsMoralCodePage/queryById',
      method: 'get',
    },

    /**
     * 服务 - 公司案例
     * 接口地址英文:/jee-cms/site/cmsNewsPage/queryById?id=1437741801162649602
     * 接口地址中文:/jee-cms/site/cmsNewsPage/queryById?id=1437741715087142914
     * type: get
     *
     */
    {
      name: 'getCase',
      url: '/jee-cms/site/cmsNewsPage/queryById',
      method: 'get',
    },
    /**
     * 资源中心 -行业报告
     * 接口地址英文:/jee-cms/site/cmsNewsPage/queryById?id=1436536402140958722
     * 接口地址中文:/jee-cms/site/cmsNewsPage/queryById?id=1436536431257817089
     * type: get
     */
    {
      name: 'getReport',
      url: '/jee-cms/site/cmsNewsPage/queryById',
      method: 'get',
    },
    /**
     * 资源中心 -知识分享
     * 接口地址英文:/jee-cms/site/cmsNewsPage/queryById?id=1436536559276363778
     * 接口地址中文:/jee-cms/site/cmsNewsPage/queryById?id=1436536586652585986
     * type: get
     */
    {
      name: 'getShare',
      url: '/jee-cms/site/cmsNewsPage/queryById',
      method: 'get',
    },
    /**
     * 联系我们 -联系方式
     * 接口地址英文:/jee-cms/site/cmsContactPage/queryById?id=1436544247485906945
     * 接口地址中文:/jee-cms/site/cmsContactPage/queryById?id=1436544285003956226
     * type: get
     */
    {
      name: 'getContact',
      url: '/jee-cms/site/cmsContactPage/queryById',
      method: 'get',
    },
    /**
     * 联系我们 工作招聘
     * 接口地址英文:/jee-cms/site/cmsNewsPage/queryById?id=1436491097131347969
     * 接口地址中文:/jee-cms/site/cmsNewsPage/queryById?id=1436490991380361217
     * type: get
     */
    {
      name: 'getJob',
      url: '/jee-cms/site/cmsNewsPage/queryById',
      method: 'get',
    },

    /**
     * 联系我们 工作搜索
     * 接口地址英文:/jee-cms/site/cmsRecruitment/list?langKey=pos-lang-cn&locationId=1436620688349151233&deptId=4f1765520d6346f9bd9c79e2479e5b12&positionTitle=,abc,&pageNo=1
     * 接口地址中文:/jee-cms/site/cmsNewsPage/queryById?id=1436490991380361217
     * type: get
     */
    /* 英文：/jee-cms/site/cmsSite/loc/list?pid=1436620579284664322
        中文：/jee-cms/site/cmsSite/loc/list?pid=1436620653565788162
        deptId:
        /jee-cms/site/cmsSite/dept/list?pid=6d35e179cd814e3299bd588ea7daed3f
        /jee-cms/site/cmsSite/dept/list?pid=c6d7cb4deeac411cb3384b1b31278596 */
    {
      name: 'getJobLoc',
      url: '/jee-cms/site/cmsSite/loc/list',
      method: 'get',
    },
    {
      name: 'getJobDept',
      url: '/jee-cms/site/cmsSite/dept/list',
      method: 'get',
    },

    /***
     * 新闻详情
     *
     */
    {
      name: 'getNewsDetail',
      url: '/jee-cms/site/cmsContent/queryById',
      method: 'get',
    },

    /***
     * 职位详情
     *
     */
    {
      name: 'getRecrDetail',
      url: '/jee-cms/site/cmsRecruitment/queryById',
      method: 'get',
    },
    /***
     * 团队详情
     *
     */
    {
      name: 'getTeamDetail',
      url: '/jee-cms/site/cmsTeamManager/queryById',
      method: 'get',
    },

    /***
     * 全局搜索
     * /jee-cms/site/cmsContent/queryAdvanced?keywords=*abc* [style:team/recruit]
     */
    {
      name: 'getQuery',
      url: '/jee-cms/site/cmsContent/queryAdvanced',
      method: 'get',
    },
    /***
     * nav
     * /jee-cms/site/cmsSite/custom
     */
    {
      name: 'getNav',
      url: '/jee-cms/site/cmsSite/nav/custom',
      method: 'get',
    },

    {
      name: 'getNavStatus',
      url: '/jee-cms/site/cmsServicePage/navStatus',
      method: 'get',
    },

    /***
     * 留言板
     * /jee-cms/site/cmsGuestBook/add
     */
    {
      name: 'postMsg',
      url: '/jee-cms/site/cmsGuestBook/add',
      method: 'post',
    },

    /***
     * 留言板
     * /jee-cms/site/cmsGuestBook/add
     */
    {
      name: 'getAllShare',
      url: '/jee-cms/site/cmsContent/queryAllShare',
      method: 'get',
    },
  ],
};
